import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  container: css`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    background-color: ${colors.white};
    padding: 24px 0px 23px 0px;
    border-bottom: 1px solid ${colors.silver};
    min-height: 72px;
  `,
  backButtonPosition: css`
    position: absolute;
    left: 8px;
  `,
  closeButtonLeft: css`
    position: absolute;
    left: 8px;
    top: 24px;
  `,
  closeButtonRight: css`
    position: absolute;
    right: 16px;
    top: 24px;
  `,
  icon: css`
    cursor: pointer;
  `,
  title: css`
    text-transform: capitalize;
  `,
};

export default styles;
